/* eslint-disable @typescript-eslint/naming-convention */
export class TelesuscripcionAccessRoles {
  public static TELESUSCRIPCIONADMIN = 'TelesuscripcionAdmin';
  public static TELESUSCRIPCIONGESTOR = 'TelesuscripcionGestor';
  public static TELESUSCRIPCIONTECNIC = 'TelesuscripcionTecnic';
  public static TELESUSCRIPCIONBO = 'TelesuscripcionBO';
  public static TELESUSCRIPCIONSUPERVISOR = 'TelesuscripcionSupervisor';
  // DT
  public static TELESUSCRIPCIONDT_NORTE = 'TelesuscripcionDT_Norte';
  public static TELESUSCRIPCIONDT_LEVANTE = 'TelesuscripcionDT_Levante';
  public static TELESUSCRIPCIONDT_CATALUÑA = 'TelesuscripcionDT_Cataluña';
  public static TELESUSCRIPCIONDT_CENTROSUR = 'TelesuscripcionDT_CentroSur';
  public static TELESUSCRIPCIONDT_CAC = 'TelesuscripcionDT_CAC';
}
